import Image, { type ImageProps } from 'next/image'
import type { FunctionComponent } from 'react'
import styles from './ResponsiveImage.module.sass'
import clsx from 'clsx'

export interface ResponsiveImageProps extends ImageProps {
	focalPointX?: number | null
	focalPointY?: number | null
}

export const ResponsiveImage: FunctionComponent<ResponsiveImageProps> = ({ focalPointX, focalPointY, style, className, ...props }) => {
	const focalPoint =
		focalPointX !== undefined && focalPointY !== undefined && focalPointX !== null && focalPointY !== null
			? `${focalPointX * 100}% ${focalPointY * 100}%`
			: undefined

	const combinedStyle = {
		...style,
		...(focalPoint ? { objectPosition: focalPoint } : {}),
	}

	return (
		<div className={styles.wrapper}>
			{/* eslint-disable-next-line jsx-a11y/alt-text */}
			<Image quality={95} className={clsx(className)} style={combinedStyle} {...props} />
		</div>
	)
}
